@let target = targetWord();
@if (target) {
  <lib-keyboard-activity
    (onCompleteWord)="completeWord()"
    (onWrongInput)="onWrongInput()"
    [assignment]="assignment()"
    [targetWord]="target"
  >
    <button
      (click)="playAudio()"
      [disabled]="isPlaying()"
      class="relative aspect-square size-20 cursor-pointer disabled:cursor-default"
      target
    >
      <div class="bg-primary-500 shadow-primary-700 shadow-sharp-md absolute inset-0 z-20 grid size-full place-items-center rounded-md p-4">
        <svg viewBox="0 0 74 60" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M64.4824 1.51393C63.3099 0.099642 61.2041 -0.112501 59.7684 1.0425C58.3327 2.1975 58.1174 4.27178 59.2899 5.68607C64.267 11.6968 67.1504 19.9114 67.1504 30C67.1504 40.0886 64.267 48.3032 59.2899 54.3139C58.1174 55.7282 58.3327 57.8025 59.7684 58.9575C61.2041 60.1125 63.3099 59.9004 64.4824 58.4861C70.5961 51.1082 73.8504 41.3379 73.8504 30C73.8504 18.6621 70.5961 8.89178 64.4824 1.51393ZM55.1024 11.8146C54.0375 10.3179 51.9557 9.96428 50.4363 11.0132C48.9168 12.0621 48.5579 14.1129 49.6227 15.6096C52.2309 19.2632 53.7504 24.1071 53.7504 30.0118C53.7504 35.9164 52.219 40.7604 49.6227 44.4139C48.5579 45.9107 48.9288 47.9614 50.4363 49.0104C51.9438 50.0593 54.0375 49.6939 55.1024 48.2089C58.6199 43.2471 60.4504 37.0361 60.4504 30C60.4504 22.9639 58.6199 16.7529 55.1024 11.8029V11.8146ZM0.150391 30.825V29.175C0.150391 26.535 0.281998 24.1896 0.712712 22.1979C1.15539 20.1707 1.96896 18.285 3.48843 16.7882C5.00789 15.2914 6.92218 14.5018 8.98003 14.0539C10.7866 13.665 12.8804 13.5236 15.2254 13.5L22.2604 4.26C24.1627 1.76143 27.1418 0.299999 30.3004 0.299999H32.2506C36.4859 0.299999 40.5059 2.99893 41.487 7.41857C42.492 11.9914 43.7124 19.6404 43.7124 30C43.7124 40.3596 42.504 48.0086 41.487 52.5814C40.5179 57.0011 36.4979 59.7 32.2506 59.7H30.3004C27.1418 59.7 24.1627 58.2386 22.2604 55.74L15.2254 46.5C12.8804 46.4764 10.7866 46.335 8.98003 45.9461C6.92218 45.51 5.00789 44.7086 3.48843 43.2118C1.96896 41.715 1.15539 39.8293 0.712712 37.8021C0.281998 35.8104 0.150391 33.465 0.150391 30.825Z"
            fill="white"
          />
        </svg>
      </div>

      <div #audioButtonAnimation class="bg-primary-500/50 absolute inset-0 aspect-square w-full rounded-full"></div>
    </button>
  </lib-keyboard-activity>
} @else {
  <p>Loading target word..</p>
}
